import { render, staticRenderFns } from "./UtilitySharingTable.vue?vue&type=template&id=50501a8b"
import script from "./UtilitySharingTable.vue?vue&type=script&lang=js"
export * from "./UtilitySharingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports